export const summaryRows: string[] = [
  'Volume 1 — HVAC Fundamentals: Heat, Thermodynamics & Psychrometrics',
  'Volume 2 — The Refrigeration Cycle & Refrigerants',
  'Volume 3 — System Components: Compressors, Condensers, Evaporators & Metering Devices',
  'Volume 4 — HVAC Systems & Air Distribution',
  'Volume 5 — Controls, Electrical Circuits & Building Automation',
  'Volume 6 — Installation, Commissioning, Troubleshooting & Maintenance',
  'Bonus 1 — HVAC Formulas & Unit Conversions Handbook',
  'Bonus 2 — Refrigeration Troubleshooting Flowcharts',
  'Bonus 3 — HVAC Preventive Maintenance Checklists',
  'Bonus 4 — Refrigerant Handling & Safety Guide',
  'Bonus 5 — HVAC&R Technical Glossary',
  '7-day money-back guarantee',
  'Instant access',
];
